import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import NewsPage from './NewsPage';
import './NewsPage.less';

export const prefix = 'bm-p-news';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: NewsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
